import React from 'react';
import { connect } from 'react-redux';
import { REF_PATH as productPath } from './Const';
import { getProductListWrapper } from './ProductWrapper.js';

class ProductDisplayWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: this.createName(props) };
  }
  componentWillMount() {
    if (!this.props.products || this.props.products.size == 0) {
      getProductListWrapper();
    }
    if (this.props.products && this.props.products.size > 0) {
      this.setState({ name: this.createName(this.props) });
    }
  }
  componentWillReceiveProps(props) {
    if (!props.products || props.products.size == 0) {
      getProductListWrapper();
    }
    if (props.products && props.products != this.props.products
      || props.products && props.id != this.props.id) {
      this.setState({ name: this.createName(props) });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.name === this.state.name) {
      return false;
    }
    return true;
  }
  createName(props) {
    let name = undefined;
    if (props.products) {
      props.products.forEach(product => {
        if (product.get('id') == props.id) {
          name = product.get('name');
        }
      });
    }
    return name;
  }
  render() {
    return (<div style={{ display: 'inline' }}>
      {this.state.name}
    </div>);
  }
}
ProductDisplayWrapper.propTypes = {
  id: React.PropTypes.oneOfType(
    [React.PropTypes.number,
      React.PropTypes.string,
    ]),
  products: React.PropTypes.object,
};
export default connect((state) => ({
  products: state.getIn(['references', 'complex', productPath]),
}))(ProductDisplayWrapper);
